export default __webpack_public_path__ + "static/media/usmanProf.765b40d1.png";